import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  Button,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  DropdownMenu,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import { tableLanguage } from "common/Constants/PageTable/tableLang";
import BooleanCellRender from "./CellRenderers/BooleanCellRender";
import DateTimeCellRender from "./CellRenderers/DateTimeCellRender";
import IncludeCellRenderer from "./CellRenderers/IncludeCellRenderer";
import ActivePassiveCellRender from "./CellRenderers/ActivePassiveCellRender";

import { Breadcrumbs, ApproveModalWithParams } from "../../CombinedComponents";

import * as moment from "moment";

import "ag-grid-enterprise";
import "ag-grid-enterprise/styles//ag-grid.css";
import "ag-grid-enterprise/styles//ag-theme-alpine.css";
import { uniqueIdentifier } from "./CellRenderers/CellFunctions";
import  ActionOperations  from "./CellRenderers/ActionOperations";

class RavenAgTableDraggeble extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusBar: {
        statusPanels: [{ statusPanel: "agAggregationComponent" }],
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading or try search panel instead.</span>',
      overlayNoRowsTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading or try search panel instead.</span>',
      icons: {
        search: '<i class="fas fa-search fa-flip-both"/>',
      },
      tooltipShowDelay: 0,
      tooltipHideDelay: 2000,
      sideBar: {
        toolPanels: [
          this.props.SearchContent
            ? {
                id: "search",
                labelDefault: this.props.t("search"),
                labelKey: "search",
                iconKey: "search",
                toolPanel: this.props.SearchContent,
              }
            : "",
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: false,
              suppressValues: false,
              suppressPivots: true,
              suppressPivotMode: true,
            },
          },
        ],
      },
      approveModal: false,
      approveMessage: "",
      sendableValue: [],
    };
  }


  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    const columnDefs = this.gridColumnApi.getColumns().map(column => {
      const colDef = column.getColDef();

      return {
        ...colDef,
        minWidth: this.setMinWidthByHeaderName(
          column.colDef.headerName,
          column.colDef.minWidth,
        ),
        flex: 1,
      };
    });

    this.gridApi.setColumnDefs(columnDefs);
    this.gridColumnApi.autoSizeColumns(
      columnDefs.map(column => column.colId),
      false,
    );
  };

  setMinWidthByHeaderName = (headerName, minWidth) => {
    if (headerName) {
      if (minWidth > 0) {
        return minWidth;
      }
      if (headerName < 14) return 150;
      else if (headerName.length < 23) return 200;
      else return 250;
    }
    return 150;
  };

  onBtnExportDataAsExcel = () => {
    let excelParams = {
      fileName: this.props.screenName + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsExcel(excelParams);
  };

  onBtnExportDataAsCsv = () => {
    let csvParams = {
      fileName: this.props.screenName + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsCsv(csvParams);
  };
  
  onRowDragEnd = e => {

  let grid =this.gridApi.rowModel.rowsToDisplay.map(item2 => item2.data)

  const gridChanges = JSON.stringify(this.props.recordList) == JSON.stringify(grid)

  if(gridChanges){
  this.setState({ approveModal: false });
  }
  else 
  this.setState({ approveModal: true });
  };
  
  scrambleAndRefreshAll = () => {
    const { onUpdateRecord } = this.props;
    this.setState({ sendableValue: [] });
    this.gridApi.rowModel.rowsToDisplay.map((item, index) => {
      this.props.recordList.forEach(value => {
        if (item.data.guid == value.guid) {
          value.priorityOrder = item.rowIndex + 1;
        }
      });
    });
    const inGrid = this.gridApi.rowModel.rowsToDisplay.map(item => item.data);
    this.state.sendableValue.push(inGrid);
    const record = {
      profileGroupGuid: this.state.sendableValue[0][0].profileGroupGuid,
      changedProfiles: this.state.sendableValue[0],
    };

    onUpdateRecord(record);
    this.setState({ approveModal: false });
  };

  approveModalWhenCancel = () => {
    let refreshGridData = [];
    let isExistSendableValue = !(
      this.state.sendableValue[0] == undefined ||
      this.state.sendableValue[0] == []
    );

    if (isExistSendableValue) {
      refreshGridData = this.state.sendableValue[0];
    } else {
      refreshGridData = this.props.recordList;
    }

    this.gridApi.setRowData(
      refreshGridData.sort((a, b) =>
        a.priorityOrder > b.priorityOrder ? 1 : -1,
      ),
    );

    this.gridApi.refreshCells({ force: true });
    this.setState({ approveModal: false });
  };

  render() {
    const { recordList, recordcolumns } = this.props;
    const { approveModal } = this.state;
    const excelStyles = [
      {
        id: "stringType",
        dataType: "String" // Excel'de metin formatında olması için
      }
    ];
    const baseColumns = [
      {
        field: this.props.actionItemsName ? "" : this.props.t("actions"),
        cellRenderer: ActionOperations,
        pinned: "left",
        suppressColumnFilter: false,
        cellRendererParams: {
          translate: this.props.t,
          edit: this.props.onEditClick,
          delete: this.props.onDeleteClick,
          detail: this.props.onDetailClick,
          dynamicFunction: this.props.onDynamicFunction,
          dynamicFunction2: this.props.onDynamicFunction2,
          dynamicFunctionIcon: this.props.dynamicFunctionIcon,
          dynamicFunctionIcon2: this.props.dynamicFunctionIcon2,
          dynamicFunctionName: this.props.dynamicFunctionName,
          dynamicFunctionName2: this.props.dynamicFunctionName2,
        },
        menuTabs: ["generalMenuTab", "columnsMenuTab"],
        singleClickEdit: true,
        suppressToolPanel: !this.props.actionItems,
        suppressColumnsToolPanel: !this.props.actionItems,
        maxWidth: this.props.actionItemsName ? 50 : 90,
        sortable: false,
        filter: false,
        hide: !this.props.actionItems,
      },

      ...recordcolumns,
    ];

    return (
      <React.Fragment>
        <div className="d-flex align-items-center">
          <div className="mb-0 card flex-grow-1">
            <Breadcrumbs
              title={
                this.props.breadCrumbTitle ? this.props.breadCrumbTitle : ""
              }
              breadcrumbItem={
                this.props.breadCrumbItem ? this.props.breadCrumbItem : ""
              }
            />
          </div>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="btn-group-horizantal" role="group">
              <Button
                type="button"
                style={{
                  display: this.props.onAddClick ? "" : "none",
                  color: "#000000",
                }}
                color="link"
                className="btn btn-outline"
                onClick={this.props.onAddClick}
              >
                <i
                  style={{ color: "#000000" }}
                  className={
                    this.props.mainButtonIcon
                      ? this.props.mainButtonIcon
                      : "bx bxs-file-plus font-size-15"
                  }
                ></i>{" "}
                {this.props.mainButton
                  ? this.props.t(this.props.mainButton)
                  : this.props.t("addNew")}
              </Button>
              <ButtonDropdown
                style={{ display: this.props.exportOption ? "" : "none" }}
                isOpen={this.state.exportDataDrp}
                toggle={() =>
                  this.setState({ exportDataDrp: !this.state.exportDataDrp })
                }
              >
                <DropdownToggle
                  style={{ color: "#000000" }}
                  caret
                  color="link"
                  className="btn btn-outline"
                >
                  <i
                    style={{ color: "#000000" }}
                    className="bx bx-export  font-size-15"
                  ></i>
                  {this.props.t("export")}
                </DropdownToggle>
                <DropdownMenu data-popper-placement="left">
                  <DropdownItem onClick={() => this.onBtnExportDataAsExcel()}>
                    {this.props.t("exportExcel")}
                  </DropdownItem>
                  <DropdownItem onClick={() => this.onBtnExportDataAsCsv()}>
                    {this.props.t("exportCsv")}
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
              <ButtonDropdown
                isOpen={this.state.operationsDrp}
                style={{ display: this.props.DropdownItems ? "" : "none" }}
                toggle={() =>
                  this.setState({ operationsDrp: !this.state.operationsDrp })
                }
              >
                <DropdownToggle caret color="link" className="btn btn-outline">
                  <i className="bx bx-dots-vertical-rounded font-size-16" />
                </DropdownToggle>
                <DropdownMenu data-popper-placement="left">
                  {this.props.DropdownItems ? (
                    this.props.DropdownItems.map(column => (
                      <DropdownItem
                        key={uniqueIdentifier()}
                        onClick={() => column.func(this.state)}
                      >
                        {this.props.t(column.operationName)}
                      </DropdownItem>
                    ))
                  ) : (
                    <></>
                  )}
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
          <ApproveModalWithParams
            show={approveModal}
            onClick={this.scrambleAndRefreshAll.bind(this)}
            customMessage={this.props.t("priorityOrderWillBeChanged")}
            onCloseClick={this.approveModalWhenCancel.bind(this)}
          />
        </div>
        <div
          className="ag-theme-alpine"
          style={{
            height: this.props.gridHeight ? this.props.gridHeight : "525px",
          }}
        >
          <AgGridReact
            defaultColDef={{
              sortable: false,
              filter: true,
              autosize: true,
              resizable: true,
              menuTabs: ["filterMenuTab", "generalMenuTab"],
              enableRowGroup: true,
              filterParams: {
                buttons: ["apply", "reset"],
              },
            }}
            frameworkComponents={{
              booleanCellRender: BooleanCellRender,
              dateTimeCellRender: DateTimeCellRender,
              includeCellRenderer: IncludeCellRenderer,
              activePassiveCellRender: ActivePassiveCellRender,
            }}
            sideBar={this.state.sideBar}
            icons={this.state.icons}
            statusBar={this.state.statusBar}
            tooltipShowDelay={this.state.tooltipShowDelay}
            tooltipHideDelay={this.state.tooltipHideDelay}
            rowData={recordList}
            columnDefs={baseColumns}
            enableRangeSelection={true}
            suppressMenuHide={true}
            enableRangeHandle={true}
            excelStyles={excelStyles}
            overlayLoadingTemplate={this.state.overlayLoadingTemplate}
            overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
            animateRows={true}
            localeText={tableLanguage}
            onGridReady={this.onGridReady}
            rowDragManaged={true}
            onRowDragEnd={this.onRowDragEnd.bind(this)}
          />
        </div>
      </React.Fragment>
    );
  }
}

RavenAgTableDraggeble.propTypes = {
  gridHeight: PropTypes.string,
  onAddClick: PropTypes.func,
  onEditClick: PropTypes.func,
  mainButton: PropTypes.any,
  mainButtonIcon: PropTypes.any,
  onDynamicFunction: PropTypes.func,
  onDynamicFunction2: PropTypes.func,
  dynamicFunctionName: PropTypes.any,
  dynamicFunctionName2: PropTypes.any,
  dynamicFunctionIcon: PropTypes.any,
  dynamicFunctionIcon2: PropTypes.any,
  actionItems: PropTypes.bool,
  actionItemsName: PropTypes.bool,
  SearchContent: PropTypes.any,
  DropdownItems: PropTypes.any,
  onDetailClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  handleAddRecordClick: PropTypes.func,
  screenName: PropTypes.string,
  exportOption: PropTypes.bool,
  recordcolumns: PropTypes.any,
  recordList: PropTypes.any,
  record: PropTypes.any,
  sizePerPage: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.any,
  onUpdateRecord: PropTypes.func,
  isUpdatePriority: PropTypes.any,
  breadCrumbTitle: PropTypes.string,
  breadCrumbItem: PropTypes.string,
  profileGroupGuidTable: PropTypes.any,
};

export default connect()(withTranslation()(RavenAgTableDraggeble));
